import React from 'react'

const Misc = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">Other Languages</h3>

        <div className="skills__box">
            <div className="skills__group">
                {/* <div className="skills__data">
                    <i className="bx bx-badge-check"></i>

                    <div>
                        <h3 className="skills__name">JAVA</h3>
                        <span className="skills__level">Interediate</span>
                    </div>
                </div> */}

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>

                    <div>
                        <h3 className="skills__name">C</h3>
                        <span className="skills__level">Intermediate</span>
                    </div>
                </div>

                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>

                    <div>
                        <h3 className="skills__name">Python</h3>
                        <span className="skills__level">Intermediate</span>
                    </div>
                </div>
            </div>

            <div className="skills__group">
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>

                    <div>
                        <h3 className="skills__name">C++</h3>
                        <span className="skills__level">Intermediate</span>
                    </div>
                </div>

                {/* <div className="skills__data">
                    <i className="bx bx-badge-check"></i>

                    <div>
                        <h3 className="skills__name">C</h3>
                        <span className="skills__level">Intermediate</span>
                    </div>
                </div> */}
            </div>
        </div>
    </div>
  )
}

export default Misc